import { createSlice } from '@reduxjs/toolkit';
import { emptyFormState } from '../emptyState';
import { postStatus } from '../status';
import { postPublisherInvite } from 'api';

// Then, handle actions in your reducers:
const publisherInviteSlice = createSlice({
  name: 'publisherInvite',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    publisherInvitePostStart: (state) => {
      state.status = postStatus.POST_START;
      state.fetching = true;
      state.error = false;
    },
    publisherInvitePostSuccess: (state, { payload }) => {
      state.status = postStatus.POST_SUCCESS;
      state.payload = payload;
      state.fetching = false;
      state.error = false;
    },
    publisherInvitePostFail: (state, { payload }) => {
      state.status = postStatus.POST_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    publisherInviteFormReset: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
      state.error = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  publisherInvitePostStart,
  publisherInvitePostSuccess,
  publisherInvitePostFail,
  publisherInviteFormReset,
} = publisherInviteSlice.actions;

// The reducer
export const publisherInviteReducer = publisherInviteSlice.reducer;

// Asynchronous thunk action
export const publisherInvitePost = (formData) => (dispatch) => {
  dispatch(publisherInvitePostStart());

  postPublisherInvite(formData)
    .then((payload) => {
      dispatch(publisherInvitePostSuccess(payload));
    })
    .catch((error) => {
      dispatch(publisherInvitePostFail(error));
    });
};
